import { apiClient } from '@/shared/api/client';

export interface UserResponse {
  id: string;
  azureAdId: string;
  email: string;
  name: string;
  role: string;
  company: string | null;
  phoneNumber: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const userService = {
  async getCurrentUser(): Promise<UserResponse> {
    return apiClient.get<UserResponse>('/users/me');
  },
};
